export enum EUserDocumentType {
	ID_CARD = "ID_CARD",
	PILOT_CERTIFICATE = "PILOT_CERTIFICATE",
	EMERGENCY_CONTACT = "EMERGENCY_CONTACT",
}
